import { useEffect } from "react";

export const ExternalRedirect = ({ to }) => {
    useEffect(() => {
        window.location.replace(to);
    }, [to]);
    return null;
};

export default ExternalRedirect;
